import { ControlledDto } from 'src/Libs/flow/installation/api/sub-devices'
import { WallboxHardwareModel } from '../models'

/**
 * Determines whether a controlled subDevice is linked to a given wallbox hardware entry.
 *
 * A subDevice is considered linked when any of the following match the hardware wallbox:
 *  - the `wallboxId`
 *  - the `macAddress` (the `wallboxId` is not always present)
 *  - the `deviceName`
 *
 * For flow, every wallbox is only linked to the EMC, so the hardware wallbox must not be
 * `VIRTUAL` and its storage serial number must match the EMC storage id.
 */
export const isSubDeviceLinkedToWallboxHardware = (
  subDevice: Nullable<ControlledDto> | null | undefined,
  hardwareWallbox: WallboxHardwareModel,
  emcStorageId: string | null,
  isFlowTheme: boolean
): boolean => {
  const condition = Boolean(
    subDevice?.evseSubTypeParameters?.wallboxId === hardwareWallbox.wallboxId ||
      // ? Unfortunately for who knows what reason, wallboxId isn't always present ¯\_(ツ)_/¯
      (subDevice?.mediaParameters && 'macAddress' in subDevice.mediaParameters && subDevice.mediaParameters?.macAddress === hardwareWallbox.mac) ||
      subDevice?.deviceName === hardwareWallbox.deviceName
  )

  return isFlowTheme
    ? // ? For flow every wallbox is only linked to the EMC
      hardwareWallbox.wallboxId !== 'VIRTUAL' && hardwareWallbox.storageSerialNumber.toString() === emcStorageId && condition
    : condition
}
